import { Loader, ColladaBlob } from "./Loader";

export class List {

    public count: number;
    public items: ColladaBlob[];

    public loadBlob(dataView: DataView, loader: Loader) {

        let offset = 0;
        this.count = dataView.getInt32(offset, true);
        offset += 4;

        this.items = new Array<ColladaBlob>();

        for (let i = 0; i < this.count; i++) {
            let identity = dataView.getInt32(offset, true);
            offset += 4;

            this.items.push(loader.getBlob(identity));
        }
    }

    public getItems<T extends ColladaBlob>() : T[] {
        return this.items as T[];
    }
}
